import React from 'react';

import { MultiSelect } from '@mantine/core';
import { OnboardingStepTemplate } from 'pages/Onboarding/OnboardingSteps/OnboardingStepTemplate';
import { useTranslation } from 'react-i18next';
import { OnboardingPrimaryInterest } from 'shared/interfaces/Onboarding';

interface PrimaryInterestsSelectionStepProps {
  updateOnboardingPrimaryInterests: (primaryInterests: OnboardingPrimaryInterest[]) => void;
}

export function PrimaryInterestsSelectionStep({
  updateOnboardingPrimaryInterests
}: PrimaryInterestsSelectionStepProps) {
  const { t } = useTranslation();

  const data = Object.entries(OnboardingPrimaryInterest)
    .map(([key, value]) => ({
      value: value,
      label: t(`ONBOARDING.PRIMARY_INTERESTS_STEP.PRIMARY_INTEREST.${key}`)
    }))
    .sort(() => Math.random() - 0.5);

  return (
    <OnboardingStepTemplate
      title={{
        text: t('ONBOARDING.PRIMARY_INTERESTS_STEP.TITLE')
      }}
      description={t('ONBOARDING.PRIMARY_INTERESTS_STEP.DESCRIPTION')}
      rightElement={
        <MultiSelect
          placeholder={t('ONBOARDING.PRIMARY_INTERESTS_STEP.PLACEHOLDER')}
          data={data}
          withinPortal
          onChange={(values) => values && updateOnboardingPrimaryInterests(values as OnboardingPrimaryInterest[])}
        />
      }
    />
  );
}
